import React from 'react';

export default function Partnerships() {
	return <div></div>;
}
